import { render, staticRenderFns } from "./PassiveChatIcon.vue?vue&type=template&id=bbf2beb6&scoped=true"
import script from "./PassiveChatIcon.vue?vue&type=script&lang=js"
export * from "./PassiveChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2beb6",
  null
  
)

export default component.exports